import { render, staticRenderFns } from "./GenerationFileType.vue?vue&type=template&id=61c85e20"
import script from "./GenerationFileType.vue?vue&type=script&lang=js"
export * from "./GenerationFileType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports